import { SmartHttp, SmartStorage } from 'smart-core-util'

const request = new SmartHttp({
    baseURL: process.env.VUE_APP_GATEWAY,
}).request;


export const miceService = {
    // get公共方法
    Get: (url, params) => {
        return request.get(url, params);
    },
    /**
     * 公共post
     */
    common: (url, params, conf) => {
        return request.post(url , params || {}, conf || {});
    },
    // 数据持久化-获取
    queryCacheData: (params) => {
        return request.post('/api/statestore/redis/query',params);
    },
    // 饿了么外卖
    // 查询餐厅分类
    getEleCategory: (params) => {
        return request.post('/api/aggregatorjmeal/shop/GetShopCategory', params);
    },
    // 查询餐厅列表
    getEleShopList: (params) => {
        return request.post('/api/aggregatorjmeal/shop/getShopList', params);
    },
    // 查询餐厅详情
    getEleShopDetail: (params) => {
        return request.post('/api/aggregatorjmeal/shop/GetShopShow', params);
    },
    // 查询餐厅菜单
    getEleShopMenu: (params) => {
        return request.post('/api/aggregatorjmeal/shop/GetShopMenu', params);
    },
    // 查询购物车
    getEleCart: (params) => {
        return request.post('/api/aggregatorjmeal/cart/QueryCart', params);
    },
    // 保存购物车
    saveEleCart: (params) => {
        return request.post('/api/aggregatorjmeal/cart/SaveCart', params);
    },
    // 保存订单
    saveEleOrder: (params) => {
        return request.post('/api/aggregatorjmeal/Order/SaveOrder', params);
    },
    // 获取用户地址
    getUserAddress: (params) => {
        return request.post('/api/aggregatorjmeal/Address/GetUserAddress', params);
    },
    // 添加饿了么地址
    addEleAddress: (params) => {
        return request.post('/api/aggregatorjmeal/Address/CreateAddress', params);
    },
    // 编辑饿了么地址
    updateEleAddress: (params) => {
        return request.post('/api/aggregatorjmeal/Address/UpdateAddress', params);
    },
    // 删除饿了么地址
    deleteEleAddress: (params) => {
        return request.post('/api/aggregatorjmeal/Address/DeleteUserAddress', params);
    },
    // 获取筛选条件
    getsettings: (params) => {
        return request.post('/api/tpm/cfg/getsettings', params)
    },
    // 获取筛选条件
    querySettings: (params) => {
        return request.post('/api/tpm/cfg/querySettings', params)
    },
    // 获取饿了么预定时间
    getBookTime: (params) => {
        return request.post('/api/aggregatorjmeal/Order/GetBookTime', params);
    },
    // 获取饿了么地址
    getNearUserAddress: (params) => {
        return request.post('/api/aggregatorjmeal/Address/GetUserNearAddress', params);
    },
    //字典查询
    queryDict: (params) => {
        return request.post('/foundation/dict/api/FnDictionary/Query', params);
    },
    // 查询发票
    getCompanyInvoice: (params) => {
        return request.get('/api/category/meal/Invoice/GetCompanyInvoice', {params: params});
    },
    // 外卖需求
    saveTakeOutItem: (params) => {
        return request.post("/api/Meal/Takeout/saveItem", params);
    },
    // 新零售
    newRetail: (params) => {
        return request.post("/api/category/meal/ele/H5/AddressLogin", params);
    },
    // 获取饿了么地址
    getEleUserAddress: (params) => {
        return request.post('/api/category/meal/ele/Address/GetUserAddress', params);
    },
    // 选择地址
    chooseAddress: (params) => {
        return request.post('/api/category/meal/ele/Address/ChooseAddress', params);
    },
    // 选择获取美团地址
    GetDianPingUrl: (params) => {
        return request.post('/api/category/takeout/takeout/GetDianPingUrl', params);
    },
    // 刷新美团需求
    refreshDianPingOrder: (params) => {
        return request.post('/api/category/takeout/takeout/RefreshOrder', params, { noblock: true });
    },
    // 获取益普生参会人
    syncAttenders: (params) => {
        return request.post('/api/Meal/Meal/SyncAttenders', params);
    },
    // 获取益普生参会人数
    QueryMiceAttenders: (params) => {
        return request.post('/api/engine/event/Attender/QueryMiceAttenders', params);
    },
}